import React from "react";
import { hydrate, render } from "react-dom";
import "antd/dist/antd.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../src/assets/stylesheets/main.scss";
import "../src/assets/stylesheets/modal.scss";

// react-snap prerenders the app into static HTML at build time. When that
// prerendered markup is present we hydrate it (attach React to the existing
// DOM) so bots see fully-populated HTML on the first request; otherwise we
// render from scratch as a normal SPA.
const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

